import React from "react";
import { Navigate } from "react-router-dom";
import { useGetUserDataQuery } from "../services/auth";
import "./TenantAdminDashboard.css";

const isTokenValid = (tokenKey = "access_token") => {
  const token = localStorage.getItem(tokenKey);
  if (!token) return false;
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    if (payload.exp * 1000 <= Date.now()) {
      localStorage.removeItem(tokenKey);
      return false;
    }
    return true;
  } catch {
    return false;
  }
};

function TenantAdminRoute({ children }) {
  const tokenValid = isTokenValid("access_token");
  const { data: userData, isLoading, isError } = useGetUserDataQuery(undefined, {
    skip: !tokenValid,
  });

  if (!tokenValid) {
    return <Navigate to="/login" replace />;
  }

  if (isLoading) {
    return (
      <div className="ta-route-loading" role="status" aria-live="polite">
        <div className="ta-spinner" aria-hidden="true" />
        <p className="ta-route-loading-text">Verifying access…</p>
      </div>
    );
  }

  if (isError || !userData) {
    return <Navigate to="/login" replace />;
  }

  const role = (userData.role || "").toLowerCase();
  if (role !== "tenant_admin") {
    return <Navigate to="/chat" replace />;
  }

  return children;
}

export default TenantAdminRoute;
